import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { hasUsableAccessToken } from '../services/api/apiClient';

export default function ProtectedRoute() {
  const location = useLocation();
  return hasUsableAccessToken()
    ? <Outlet />
    : <Navigate to="/login" replace state={{ from: location.pathname }} />;
}
